<script>
    export default {
        data() {
            return {
                selectedOption: null,
                assignedProducts: this.productRelations,
                results: null,
                products: null,
                sizeInput: '',
            }
        },
        props: {
            mediaId: Number,
            productRelations: Array,
            sizes: Array,
            sizeDefault: String,
        },
        mounted() {
            this.getProducts();
        },
        methods: {
            assignMediaToModel() {
                axios.put(Scoop.baseUrl + '/mediaserver/media/' + this.mediaId + '/manager/Media2ProductManager',
                    this.selectedOption
                ).then((response) => {
                    this.selectedOption = null;
                    this.assignedProducts.push(response.data);
                });
            },
            deleteAssignment(productId) {
                axios.patch(Scoop.baseUrl + '/mediaserver/media/' + this.mediaId + '/manager/Media2ProductManager', {
                    'method': 'delete',
                    'product_id': productId,
                }).then((response) => {
                    this.assignedProducts = response.data;
                });
            },
            search(search, loading) {
                loading(true);
                this.getProducts(search, loading);
            },
            getProducts(search, loading) {
                let url = Scoop.baseUrl + '/mediaserver/media/' + this.mediaId + '/manager/Media2ProductManager?method=search';

                if (search) {
                    url += '&search=' + search;
                }

                axios.get(url).then(response => {
                    this.products = response.data;

                    if (loading !== undefined) {
                        loading(false);
                    }
                });
            },
            storeSizeInput(productId) {
                axios.put(Scoop.baseUrl + '/products/' + productId, {
                   size: this.sizeInput
                }).then((response) => {
                    $('#update-product-size-' + productId).modal('hide');
                    let index = _.findIndex(this.assignedProducts, ['product_id', productId]);
                    let assignment = this.assignedProducts[index];
                    assignment.product = response.data;
                });
            }
        },
        computed: {
            options() {
                return _.map(this.products, function (product) {
                    return {label: product.shop_material_no, value: product.id};
                });
            },
            selected() {
                return _.sortBy(_.map(this.assignedProducts, function (productRelation) {
                    productRelation.value = productRelation.product_id;
                    return productRelation;
                }), 'label');
            },
            availableOptions() {
                return _.filter(this.options, (option) => {
                    return _.find(this.selected, option) === undefined;
                });
            }
        },
        watch: {
            selectedOption() {
                if (this.selectedOption) {
                    this.assignMediaToModel();
                }
            }
        },
    }
</script>

<template>
    <div>
        <h5 v-text="__('collections.available_products')"></h5>
        <v-select @search="search" :options="availableOptions" v-model="selectedOption" class="m-b"></v-select>

        <div v-if="!assignedProducts.length" class="alert alert-info" v-text="__('products.no_related_products')"></div>
        <div v-else>
            <h5 v-text="__('products.assigned_products')"></h5>
            <ul class="products">
                <li v-for="option in selected">
                    <span v-text="option.product.shop_material_no"></span>
                    <Lightbox
                        :id="'update-product-size-' + option.value"
                        :headline="'Size: ' + option.product.shop_material_no"
                        class="inline"
                        @lightboxopening="sizeInput = option.product.size || sizeDefault"
                        @lightboxclosing="sizeInput = option.product.size || sizeDefault"
                    >
                        <span slot="open-template">({{ option.product.size || sizeDefault }})</span>
                        <div slot="body" class="row">
                            <select class="form-control" v-model="sizeInput">
                                <option v-for="size in sizes">{{ size }}</option>
                            </select>
                        </div>
                        <div slot="footer">
                            <button type="button" class="btn btn-white pull-left" data-dismiss="modal" v-text="__('scoop-os.common.close')"></button>
                            <button type="button" class="btn btn-primary" v-text="__('scoop-os.common.save')" @click="storeSizeInput(option.value)"></button>
                        </div>
                    </Lightbox>
                    <a @click="deleteAssignment(option.value)" class="m-l-xs text-danger"><i class="fa fa-times"></i></a>
                </li>
            </ul>
        </div>
    </div>
</template>
